export const validateExternalApi = function (api) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }
  return keys.forEach(key => {
    if (!api || typeof api[key] !== 'function') {
      throw new Error(`bsiManager: ${String(key)} must be a function`);
    }
  });
};
export const readCookie = name => {
  const regex = RegExp('^\\s*' + name + '=\\s*(.*?)\\s*$');
  let cookies = [];
  try {
    cookies = window.document.cookie.split(';');
  } catch (e) {}
  for (const cookie of cookies) {
    const match = cookie.match(regex);
    if (match) {
      return match[1];
    }
  }
  return null;
};
export const writeCookie = (name, value, expires, path, domain) => {
  const cookie = `${name}=${value}; expires=${new Date(expires).toUTCString()}; path=${path}; domain=${domain}; SameSite=None; Secure`;
  try {
    window.document.cookie = cookie;
  } catch (e) {}
};
export const destroyCookie = (name, path, domain) => {
  writeCookie(name, null, 0, path, domain);
};
export const getNextLocalMidnight = () => new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0);
//# sourceMappingURL=utils.js.map